import React, { useContext } from 'react';

import AssignmentMapContext from 'modules/assignment-map/map/context';

import { StyledLoader } from './styled';

const Loaders = () => {
  const { fetchingDriverPositions } = useContext(AssignmentMapContext);

  if (fetchingDriverPositions) {
    return <StyledLoader />;
  }

  return null;
};

export default Loaders;
